import { BaseModule } from "by/gamefactory/cityversetycoon/composition/module/BaseModule";
import { LatestNewsPopupScene } from "./scenes/LatestNewsPopupScene";
import { LatestNewsModuleFlowExecutor } from "./LatestNewsModuleExecutor";
import { LatestNewsResourcePackage } from "./resources/LatestNewsResourcePackage";
import { ParamDescription } from "by/gamefactory/cityversetycoon/composition/module/ParamDescription";
import { LatestNewsController } from "./controllers/LatestNewsController";
import { DynamicResourcesPackage } from "resources/DynamicResourcesPackage";
import { CancellationToken } from "async/CancellationToken";

export class LatestNewsModule extends BaseModule<void> {
    private newsResources: LatestNewsResourcePackage;

    public override async build(): Promise<void> {
        this.internalContainer.register(LatestNewsModuleFlowExecutor, LatestNewsModuleFlowExecutor);
        this.internalContainer.register("ILatestNewsController", LatestNewsController);
        this.internalContainer.register(LatestNewsPopupScene, LatestNewsPopupScene);
        this.internalContainer.register("LatestNewsPopupSceneFactory", {
            useValue: async (newsDynamicResources: DynamicResourcesPackage, cancellationToken: CancellationToken) => {
                return await this.resolveWithParams(
                    this.internalContainer,
                    LatestNewsPopupScene,
                    new ParamDescription(DynamicResourcesPackage, newsDynamicResources),
                    new ParamDescription(CancellationToken, cancellationToken)
                );
            }
        });

        this.newsResources = new LatestNewsResourcePackage();
        await this.newsResources.load();
        this.internalContainer.registerInstance(LatestNewsResourcePackage, this.newsResources);

        await super.build();
    }

    public async start(): Promise<void> {
        const executor = await this.internalContainer.resolve(LatestNewsModuleFlowExecutor);
        await executor.execute(this);
        this.dispose();
    }

    public override dispose(): void {
        this.newsResources.destroy();
        super.dispose();
    }
}